var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpaceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22154_103080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.9987 14.6654C7.47146 14.6654 8.66536 13.4715 8.66536 11.9987C8.66536 10.5259 7.47146 9.33203 5.9987 9.33203C4.52594 9.33203 3.33203 10.5259 3.33203 11.9987C3.33203 13.4715 4.52594 14.6654 5.9987 14.6654Z",
    fill: "#535A60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3346 16.6654C13.2551 16.6654 14.0013 15.9192 14.0013 14.9987C14.0013 14.0782 13.2551 13.332 12.3346 13.332C11.4142 13.332 10.668 14.0782 10.668 14.9987C10.668 15.9192 11.4142 16.6654 12.3346 16.6654Z",
    fill: "#535A60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.668 11.332C14.8771 11.332 16.668 9.54117 16.668 7.33203C16.668 5.12289 14.8771 3.33203 12.668 3.33203C10.4588 3.33203 8.66797 5.12289 8.66797 7.33203C8.66797 9.54117 10.4588 11.332 12.668 11.332Z",
    fill: "#535A60"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22154_103080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceIcon);
export default __webpack_public_path__ + "static/media/spaceIcon.c2eda75cd9b46f390f9393820b2288f7.svg";
export { ForwardRef as ReactComponent };